import { render } from "./SponsorProposal.vue?vue&type=template&id=357b82a8&scoped=true"
import script from "./SponsorProposal.vue?vue&type=script&lang=js"
export * from "./SponsorProposal.vue?vue&type=script&lang=js"

import "./SponsorProposal.vue?vue&type=style&index=0&id=357b82a8&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357b82a8"]])

export default __exports__